export const toggleOptions = {
    default: [
        'Collect And Get',
        'Instant Win (Winning Moments)',
        'Instant Win (Winning Moments + Guaranteed Prize)',
        'Instant Win (Always Win)',
    ],
    collectAndGet: {
        standard: 'Collect & Get',
    },
    instantWin: [
        'Instant Win (Winning Moments)',
        'Instant Win (Winning Moments + Guaranteed Prize)',
        'Instant Win (Always Win)',
    ],
    autoCollectAndGet: {
        noCodes: 'Auto Colect And Get (Without PinCodes)',
        withCodes: 'Auto Colect And Get (With PinCodes)',
    },
};
export const tooltipsText = {
    market: `If you need to select another market, go to the campaign profile and open "General Info"
            where the markets can be managed in case you have corresponding permissions.`,
    language: `Only one language can be selected as a default per promotion.
            The list of languages is updated based on the selected market, but you can also open the full list of languages if needed.`,
    email: `Select the email template if you need to send a voucher and redemption instructions to winners.`,
    ajoEmail: `Provide the name of the template created in AJO and if user id origin is CDS`,
    redemptionApp: 'Select if vouchers need to be redeemed by external app',
};
